import React, { PropsWithChildren } from 'react'
import { toast } from '@workwhile/ui'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useDeleteBillRateMutation } from 'queries/billRates/useDeleteBillRateMutation'
import { useBillRatesWorkflowsContextValue } from '../../../context/BillRatesWorkflowsProvider'

type DeleteBillRateFlowContextState = {
  state: {
    isPending: boolean
    isError: boolean
    errorMessage: string | undefined
  }
  actions: {
    confirm: () => void
  }
}

const [Context, useDeleteBillRateFlowContextValue] =
  createContext<DeleteBillRateFlowContextState>({
    name: 'DeleteBillRateFlowContext',
  })

export const DeleteBillRateFlowProvider = ({ children }: PropsWithChildren) => {
  const { deleteBillRateFlow } = useBillRatesWorkflowsContextValue()
  const { mutate, isPending, isError, error } = useDeleteBillRateMutation()

  const value: DeleteBillRateFlowContextState = {
    state: {
      isPending,
      isError,
      errorMessage: parseErrorMessage(error),
    },
    actions: {
      confirm: () => {
        const { billRate, close } = deleteBillRateFlow
        if (!billRate) return
        mutate(
          { billRateId: billRate.id },
          {
            onSuccess: () => {
              toast.success('Bill rate deleted successfully', {
                position: 'top-center',
              })
              close()
            },
          }
        )
      },
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useDeleteBillRateFlowContextValue }
